import { ConsentAwareContract } from '@/services/contracts/consent-aware.contract'
import appStore from '@/stores/app.store'

class CalendlyService implements ConsentAwareContract {
  activate(): void | Promise<void> {
    appStore.setCalendlyConsentGiven(true)
  }

  deactivate(): void | Promise<void> {
    // TODO: implement deactivate method
  }
}

export default new CalendlyService()
